import { Typography } from "@mui/material";
import { PrimaryAlert } from "react-common-ui-library/FPACT/Alerts";
import { useIntl } from "react-intl";
import {
  INFO,
  TARGET_BLANK,
  TRUE,
  FIND_PROVIDER_LINK,
  FIND_PROVIDER_URL,
} from "../../../Constants/CommonConstants";
import { StyledInlineLink } from "../../../Styles/Common/CommonStyles";
import { NAME_AND_CONTACT_FIND_PROVIDER_CONTENT_2 } from "../../../Constants/NameAndContactConstants";

import EndpointService from "../../../Services/EndpointService";

/**
 * @description Alert to show the find a provider link and description that can be used in name and contact screen.
 * @returns {ReactNode} Render the alert with info severity, description and find a provider link.
 */

const NameAndContactInfoAlert = () => {
  const intl = useIntl();

  return (
    <PrimaryAlert
      severity={INFO}
      content={
        <Typography id={NAME_AND_CONTACT_FIND_PROVIDER_CONTENT_2}>
          {intl.formatMessage(
            {
              id: NAME_AND_CONTACT_FIND_PROVIDER_CONTENT_2,
            },
            {
              link: (
                <StyledInlineLink
                  id={FIND_PROVIDER_LINK}
                  href={EndpointService(FIND_PROVIDER_URL)}
                  target={TARGET_BLANK}
                  aria-label={`${intl.formatMessage({
                    id: FIND_PROVIDER_LINK,
                  })}`}
                >
                  {intl.formatMessage({ id: FIND_PROVIDER_LINK })}
                </StyledInlineLink>
              ),
            }
          )}
        </Typography>
      }
      hideIcon={TRUE}
    />
  );
};

export default NameAndContactInfoAlert;
